'use strict';

import {VIEW_INFO} from "../../ams/constants/view.constants.js";
import {
    INTERVIEW_SET_TYPES,
    INTERVIEW_SET_CATEGORIES
} from '../../interview-v2/constants/interview.constant.js';

angular.module('harriApp')
    .controller('InterviewController', ['$scope', 'hUser', '$stateParams', 'InterviewViewService', 'InterviewDataService', '$state', 'hFormReference', 'registrationApi', 'googleMaps','$filter','digitalApp','deviceChecker', '$modal', 'positionsDataService',
        function ($scope, hUser, $stateParams, InterviewViewService, InterviewDataService, $state, hFormReference, registrationApi, googleMaps,$filter,digitalApp,deviceChecker, $modal, positionsDataService) {

        var user = hUser.data.user;
        var applicationId = $stateParams.application_id;
        var forms = new FormGroup();
        $scope.weekRange = {};
        $scope.showInterview = false;
        $scope.INTERVIEW_SET_TYPES = INTERVIEW_SET_TYPES;
        $scope.INTERVIEW_SET_CATEGORIES = INTERVIEW_SET_CATEGORIES;

        var viewHandlers = {
            onClick: function (slot) {
                $scope.selectedSlot = slot;
            }
        };

        var viewService = InterviewViewService(viewHandlers);
        viewService.employeeMode = true;
        viewService.stepSize = 15;

        var availability_matrix = {
            days: [
                {day: "MON", day_fullname: "Monday", is_evening: false, is_morning: false},
                {day: "TUE", day_fullname: "Tuesday", is_evening: false, is_morning: false},
                {day: "WED", day_fullname: "Wednesday", is_evening: false, is_morning: false},
                {day: "THU", day_fullname: "Thursday", is_evening: false, is_morning: false},
                {day: "FRI", day_fullname: "Friday", is_evening: false, is_morning: false},
                {day: "SAT", day_fullname: "Saturday", is_evening: false, is_morning: false},
                {day: "SUN", day_fullname: "Sunday", is_evening: false, is_morning: false}
            ]
        };

        //get signed pdf link
        var getESignedSecondPhase = function(){
            //hold E-signed 2nd phase
            InterviewAPI.getPdfSignedLink($scope.application.job.id,user.id).then(function(result){
                $scope.eSignedSecondPhase = result;
            })
        };

        const interviewRoutes = {
            interview: "interview",
            interviewReschedule: "interviewReschedule"
        }

        $scope.whenVerificationFinished = function($event) {
            $scope.showInterview = $event.verified;
        };

        $scope.saveSecondPhase = function(showError) {
            $scope.savingSecondPhase = true;
            $scope.saveSecondPhaseErr = "";

            SettingsAPI.saveSecondPhase(applicationId, $scope.personalInformationForm.data.email)
                .then(function (res) {

                    $scope.savingSecondPhase = false;
                    $("#verify-account-modal").modal("hide");

                    $('#SubmitScheduleBtn').button('reset');
                    $('#SubmitScheduleBtn').removeClass('loading');

                    $scope.progressTracker.changeState("pre_interview", ProgressTracker.States.COMPLETE);

                    if ($scope.application.interview_set.type !== "OPEN_DAY") {
                        $scope.progressTracker.changeState("schedule_interview", ProgressTracker.States.NEW);
                        $scope.progressTracker.goTo('schedule_interview');
                        // firing an event update calendar offset
                        $scope.$broadcast('scheduleInterview:visible');
                    } else {
                        $scope.progressTracker.changeState("confirm_interview", ProgressTracker.States.NEW);
                        $scope.progressTracker.goTo('confirm_interview');
                    }

                    //get link of signed pdf
                    getESignedSecondPhase();
                },
                function(err) {
                    $scope.savingSecondPhase = false;

                    if (showError) {
                        $scope.saveSecondPhaseErr = "email";
                    }

                    $scope.$digest();

                    if (err.status === 412) {
                        $("#verify-account-modal").modal("show");
                    }
                    else if (err.data && err.data.data) {
                        hAlert($filter("translate")("Error!"), $filter("translate")(err.data.data));
                    }
                    else {
                        console.error(err);
                    }

                    $('#SubmitScheduleBtn').button('reset');
                    $('#SubmitScheduleBtn').removeClass('loading');
                });
        };

        // End of Interview Page
        // Pre-Interview Application
        $scope.savePreInterview = function() {
            $scope.isSigningDocument = true;
            if($scope.brandQuestionsForm.data.answers[7].answer == 'part-time' && !$scope.availabilityMatrixForm.validator.validate(true)) {
                setTimeout(function () {
                    var errorOffset = $('#week-availability').find(".error").parent().offset().top;
                    var containerScroll = $(".side-bar-scroll").scrollTop();
                    $(".side-bar-scroll").animate({scrollTop: containerScroll + errorOffset - 120}, 200);
                }, 1);
                $scope.isSigningDocument = false;
                return;
            }

            $scope.brandQuestionsForm.data.answers[8] =  {code : "8", answer : $scope.availabilityMatrixForm.getSelectedDays()};

          $('#SubmitScheduleBtn').button('loading');
          $('#SubmitScheduleBtn').addClass('loading');

            // true, to validate hidden and visible forms (validateHidden)
            forms.saveAll(true)
                .then(
                function(res){
                    $scope.isSigningDocument = false;
                    $scope.saveSecondPhase();
                },
                function(err){
                    $scope.isSigningDocument = false;
                        if (err[0].code == BaseForm.VALIDATION_ERROR)
                        {
                          $(".error")
                            .parents(".accordion")
                            .addClass('open');

                            var errorOffset = $('.' + err[0].name).find(".error").parent().offset().top;
                            var containerScroll = $(".side-bar-scroll").scrollTop();
                            $(".side-bar-scroll").animate({scrollTop: containerScroll + errorOffset - 110}, 200);
                        }

                        $('#SubmitScheduleBtn').button('reset');
                        $('#SubmitScheduleBtn').removeClass('loading');
                });
        }

        // End of pre-Interview Application

        // Schedule-Interview Application

        // TODO: Add schedule-interview specific logic here

        //move to confirm interview view
        $scope.goToConfirm = function(){
          if(!$scope.interviewSlots || !$scope.interviewSlots.length || !$scope.selectedSlot.start_time){
            hAlert($filter("translate")("Error"), $filter("translate")("Please, select a time slot to continue!"));
            return;
          }

          if($scope.secondPhaseEnabled && $scope.application.interview_set.location){
            $scope.progressTracker.changeState("pre_interview", ProgressTracker.States.COMPLETE);
          }

          $scope.progressTracker.changeState("schedule_interview", ProgressTracker.States.COMPLETE);
          $scope.progressTracker.changeState("confirm_interview", ProgressTracker.States.NEW);
          $scope.progressTracker.goTo('confirm_interview');


          //Calendar
          var calendarInterviewTitle = `${VIEW_INFO[AMSAPI.INTERVIEW].title} ${$filter("translate")("with")} ${$scope.application.job.brand.name}`;
          $scope.calendarICSFormat = publicConfiguration.getBaseAPI("InterviewServers") +
                                    'candidates/interview_sets/' + $scope.application.interview_set.id +
                                    '/applications/' + $scope.application.application_id + '/calendar?slot_ids=' + $scope.selectedSlot.id;


          $scope.calendarGoogleFormat = 'https://www.google.com/calendar/render?action=TEMPLATE&text='+encodeURIComponent(calendarInterviewTitle)
            +'&dates='+encodeURIComponent(moment.utc($scope.selectedSlot.start_time).format("YYYYMMDDTHHmmss")+'Z')
            +'/'+encodeURIComponent(moment.utc($scope.selectedSlot.end_time).format("YYYYMMDDTHHmmss")+'Z')
            + (($scope.application.interview_set.location && $scope.application.interview_set.location.formatted_address) ? '&location='+encodeURIComponent($scope.application.interview_set.location.formatted_address) : '');
        };

        $scope.requestNewTime = function() {

            $modal({
                controller: 'InterviewActionsModalController',
                templateUrl: '../modules/interview/views/modals/interview_actions_modal.html',
                show: true,
                resolve: {
                    modalData: function () {
                        return {
                            app_id: $scope.application.application_id,
                            interview_set_id: $scope.application.interview_set.id,
                            brand: {
                                name: $scope.application.job.brand.name,
                                id: $scope.application.job.brand.id
                            },
                            status: InterviewV2API.INTERVIEW_STATUSES.REQUEST_NEW_TIME
                        }
                    }
                }
            });
        };

        $scope.declineInvite = function() {
            if($scope.application.status === InterviewV2API.INTERVIEW_STATUSES.CONFIRMED) {
                hConfirm({
                    title: $filter("translate")("Decline interview"),
                    text: $filter("translate")("Are you sure you want to decline your interview?"),
                    confirmButton: $filter("translate")("Yes"),
                    cancelButton: $filter("translate")("No"),
                    callback: async function (confirmed) {
                        if (!confirmed) return;

                        try {
                            const interviewSetId = $scope.application.interview_set.id;
                            const appId = $scope.application.application_id;

                            await InterviewV2API.declineInterview(interviewSetId, appId);
                            $state.go("appLayout.harriSH.dashboard");
                            $scope.$digest();
                        } catch (error) {
                            console.error("Failed to decline interview:", error);
                            hAlert(
                                $filter("translate")("Something went wrong!"),
                                error?.data?.errors?.[0]?.detail || $filter("translate")("Failed to decline the interview.")
                            );
                        }
                    }
                });
            } else {
                $modal({
                    controller: 'InterviewActionsModalController',
                    templateUrl: '../modules/interview/views/modals/interview_actions_modal.html',
                    show: true,
                    resolve: {
                        modalData: function () {
                            return {
                                app_id: $scope.application.application_id,
                                interview_set_id: $scope.application.interview_set.id,
                                brand: {
                                    name: $scope.application.job.brand.name,
                                    id: $scope.application.job.brand.id
                                },
                                status: InterviewV2API.INTERVIEW_STATUSES.DENIED
                            }
                        }
                    }
                });
            }
        };


        // End of Schedule-Interview Application

        // Confirm-Interview Application

    /***
     * move back to schedule interview view
     */
        $scope.backToScheduleInterview = function(){
            if($scope.secondPhaseEnabled) {
                $scope.progressTracker.changeState("pre_interview", ProgressTracker.States.COMPLETE);
            }
            $scope.progressTracker.changeState("schedule_interview", ProgressTracker.States.NEW);
            $scope.progressTracker.changeState("confirm_interview", ProgressTracker.States.DISABLED);
            $scope.progressTracker.goTo('schedule_interview');
            // firing an event update calendar offset
            $scope.$broadcast('scheduleInterview:visible');
        }

        $scope.confirmInterview = async () => {

            $scope.confirmingInterview = true;

            if($scope.isRescheduleFlow) {
                try {
                    await InterviewV2API.rescheduleInterview($scope.application.interview_set.id, $scope.application.application_id, $scope.selectedSlot.id);
                    $state.go("appLayout.harriSH.dashboard");
                } catch (error) {
                    console.error(error);
                    hAlert(
                        $filter("translate")("Something went wrong!"),
                        error?.data?.errors?.[0]?.detail
                    );
                    $state.go("appLayout.harriSH.dashboard");
                } finally {
                    delete $scope.confirmingInterview;
                    $scope.$digest();
                }
            } else {

                InterviewV2API.confirmApplication($scope.application.interview_set.id, $scope.application.application_id, $scope.selectedSlot.id)
                    .then(function () {
                            delete $scope.confirmingInterview;
                            $state.go("appLayout.harriSH.dashboard");
                        },
                        function (error) {
                            var errorMsg = error && error.data;
                            delete $scope.confirmingInterview;
                            // TODO: Fix this, temporarily solution for translating error from server
                            console.error(error);
                            if (error.data && error.data.errors && error.data.errors.length) {
                                hAlert($filter("translate")("Some thing went wrong!"), error.data.errors[0].detail);
                            }
                            $state.go("appLayout.harriSH.dashboard");
                        });
            }
        };

        // TODO: Add confirm-interview specific logic here

        // End of confirm-Interview Application

        $scope.closeTimezoneNote = function () {
            $scope.timeZones = {};
        };

        $scope.onWeekSelected = function (weekRange) {
            $scope.weekRange.from = weekRange.from;
            $scope.weekRange.to = weekRange.to;
            viewService.init(weekRange.from);
            viewService.drawAll();
        };

        $scope.addToCalenderICSFormat = function () {
            InterviewV2API.getInterviewApplicationCalenderInvite($scope.application.interview_set.id, $scope.application.application_id, $scope.selectedSlot.id)
                .then(function(res){
                    Utils.downloadFile(res,'interview.ics', 'text/calendar')
                });
        };

            var init = function () {
                var startOfWeek = "MON";

                $scope.isMobile = deviceChecker.isMobile();

                $scope.loading = true;
                $scope.SignatureOfApplicant = false;

                if (digitalApp && digitalApp.data) {
                    // second phase
                    $scope.secondPhaseEnabled = !!digitalApp.data.brand.second_phase_enabled && !digitalApp.data.second_phase_complete;
                    $scope.secondPhaseCompleted = digitalApp.data.second_phase_complete;
                }

                $scope.isRescheduleFlow = $state.current.name === interviewRoutes.interviewReschedule;

                var applicationId = $stateParams.application_id;
                var interviewType = $stateParams.interview_type;
                InterviewV2API.getApplicationDetails(applicationId, "AVAILABLE", interviewType, $scope.isRescheduleFlow)
                    .then(function (data) {

                        $scope.application = data;

                        $scope.application.interview_set.slots = $scope.application.interview_set.slots || [];

                        $scope.application.interview_set.slots.sort(function (slot1, slot2) {
                            return moment(slot1.start_time) - moment(slot2.start_time);
                        });

                        $scope.isInterviewV2ServiceEnabled = ['INVITE', 'PHONE', 'SECOND_INVITE'].indexOf($scope.application.interview_set.type) > -1;

                        if ($scope.application.job.brand.time_zone) {
                            $scope.timeZones = {
                                brand: parseInt((-moment().tz($scope.application.job.brand.time_zone).zone()) / 60),
                                user: parseInt((-moment().zone()) / 60)
                            };
                        }

                        //get e-Signed Second Phase link
                        if($scope.secondPhaseCompleted){
                            getESignedSecondPhase();
                        }
                        //hold E-signed 2nd phase
                        $scope.eSignedSecondPhase = '';

                        //schedule interview
                        $scope.selectedSlot = {};
                        $scope.interviewSlots = null;
                        $scope.today = new Date();

                        $scope.availabilityMatrixForm = new AvailabilityMatrixForm($scope);
                        $scope.availabilityMatrixForm.load(availability_matrix);

                        $scope.personalInformationForm = forms.addForm(new PersonalInformationForm($scope));
                        $scope.educationForm = forms.addForm(new EducationForm($scope, user.id, googleMaps, true));
                        $scope.experienceForm = forms.addForm(new ExperienceForm($scope, user.id, googleMaps, positionsDataService));
                        $scope.skillsForm = forms.addForm(new SkillsForm($scope, registrationApi, $scope.application.job.id));
                        $scope.referencesForm = forms.addForm(new ReferencesForm($scope, hUser));
                        $scope.brandQuestionsForm = forms.addForm(new BrandQuestionsForm($scope, $scope.application.job.brand, { 'applicationId': $scope.application.application_id }, $scope.application.job));
                        $scope.signatureForm = forms.addForm(new SignatureForm($scope, applicationId));

                        // Load heavy data forms after few milliseconds
                        setTimeout(function(){
                            $scope.educationForm.load()
                                .then(function(){
                                    $scope.experienceForm.load()
                                        .then(function() {
                                            $scope.skillsForm.load()
                                                .then(function(){
                                                    $scope.$digest();
                                                })
                                        })
                                });
                        }, 500);

                        $scope.member = null;
                        $scope.data = {
                            reference: []
                        };

                        MemberAPI.getProfile(user.id).then(function(memberDetails) {
                            $scope.member = memberDetails;
                            $scope.$digest();
                        });

                        $scope.interviewSlots = $scope.application.interview_set.slots;

                        var progressTrackerItems = [];
                        var disableLastStep = false;
                        if($scope.secondPhaseEnabled && $scope.application.interview_set.location){
                            progressTrackerItems.push({
                                id: 'pre_interview',
                                title: $filter("translate")("employer pre-interview application"),
                            });
                            disableLastStep = true;
                        }

                        if ($scope.application.interview_set.type !== "OPEN_DAY") {
                            progressTrackerItems.push({
                                id: 'schedule_interview',
                                title: $scope.isRescheduleFlow
                                    ? $filter("translate")("reschedule interview")
                                    : $filter("translate")("schedule interview"),
                            });
                            disableLastStep = true;
                        }

                        progressTrackerItems.push({
                            id: 'confirm_interview',
                            title: $filter("translate")("confirm interview"),
                            disabled: disableLastStep
                        });

                        $scope.progressTracker = new ProgressTracker($scope, {
                            autoScroll: false,
                            items: progressTrackerItems,
                            onInitialized: function (element) {

                                if($scope.secondPhaseEnabled && $scope.application.interview_set.location){
                                    $scope.progressTracker.goTo("pre_interview");
                                }
                                else if ($scope.application.interview_set.type !== "OPEN_DAY") {
                                    $scope.progressTracker.goTo("schedule_interview");

                                    // firing an event update calendar offset
                                    $scope.$broadcast('scheduleInterview:visible',{});
                                } else {
                                    $scope.progressTracker.goTo("confirm_interview");

                                    //Calendar
                                    $scope.calendarICSFormat = publicConfiguration.getBaseAPI("InterviewServers") +
                                        'candidates/interview_sets/' + $scope.application.interview_set.id +
                                        '/applications/' + $scope.application.application_id + '/calendar?' +
                                        $.param($scope.application.interview_set.slots.map(function (slot) {
                                            return {
                                                name: 'slot_ids',
                                                value: slot.id
                                            }
                                        }));
                                    //TODO: Change this to authenticated google calendar
                                    var calendarInterviewTitle = $filter("translate")("Job interview with")+' '+$scope.application.job.brand.name;
                                    $scope.calendarGoogleFormat = 'https://www.google.com/calendar/render?action=TEMPLATE&text='+encodeURIComponent(calendarInterviewTitle)
                                        + (($scope.application.interview_set.location && $scope.application.interview_set.location.formatted_address) ? '&location='+encodeURIComponent($scope.application.interview_set.location.formatted_address) : '')
                                        + '&' + $.param($scope.application.interview_set.slots.map(function (slot) {
                                            return {
                                                name: 'dates',
                                                value: encodeURIComponent(moment.utc(slot.start_time).format("YYYYMMDDTHHmmss")+'Z') + '/' + encodeURIComponent(moment.utc(slot.end_time).format("YYYYMMDDTHHmmss")+'Z')
                                            }
                                        }));
                                }

                            },
                            onStateChanged: function (item, newState, oldState) {
                            },
                            onActiveChanged: function (activeItem, lastActiveItem) {
                                $scope.activeState = activeItem;

                                if ($scope.activeState.id === "schedule_interview" && $scope.interviewSlots.length) {

                                    $scope.interviewSlots.sort(function (slot1, slot2) {
                                        return moment(slot1.start_time) - moment(slot2.start_time);
                                    });

                                    var weekStartDate = getWeekStart(moment($scope.interviewSlots[0].start_time).startOf('day'), startOfWeek);

                                    $scope.weekRange.from = weekStartDate;
                                    $scope.weekRange.to = weekStartDate.clone().add(6, 'days');

                                    InterviewDataService.parseData(weekStartDate, $scope.interviewSlots);
                                    viewService.init(weekStartDate);

                                    var interviewInterval = setInterval(function () {
                                        if ($('#interview-calendar-v2').length) {
                                            viewService.drawAll();
                                            clearInterval(interviewInterval);
                                        }
                                    }, 100);
                                }
                            },
                            onItemClick: function (event, item) {

                                if (item.state === ProgressTracker.States.COMPLETE) return;

                                $scope.progressTracker.goTo(item.id);
                            }
                        });

                        $scope.loading = false;
                        $scope.$digest();

                    }, function (error) {
                        const rescheduleError = error?.data?.errors?.[0]?.detail;
                        if ($scope.isRescheduleFlow && rescheduleError?.code === InterviewV2API.ERROR_CODES.RESCHEDULE_NOT_ALLOWED) {
                            const interviewSetId = rescheduleError.details?.interview_set_id;
                            hConfirm({
                                title: $filter("translate")("Reschedule interview"),
                                text: $filter("translate")("Unfortunately, you can’t reschedule your interview because it’s less than 24 hours in the future. Would you like to proceed in declining your interview?"),
                                confirmButton: $filter("translate")("Yes"),
                                cancelButton: $filter("translate")("No"),
                                callback: async function (confirmed) {
                                    if (confirmed) {
                                        try {
                                            await InterviewV2API.declineInterview(interviewSetId, applicationId);
                                            $scope.$digest();
                                            $state.go("appLayout.harriSH.dashboard");
                                        } catch (error) {
                                            console.error("Failed to decline interview:", error);
                                            hAlert(
                                                $filter("translate")("Something went wrong!"),
                                                error?.data?.errors?.[0]?.detail || $filter("translate")("Failed to decline the interview.")
                                            );
                                        }
                                    } else {
                                        $state.go("appLayout.harriSH.dashboard");
                                    }
                                }
                            });
                        }
                        console.error(error);
                    });
            };
            init();

            $scope.isSlotInPast = function (slot) {
                return moment(slot.start_time).isSameOrBefore(moment().add(1, 'hour'), 'hour');
            };

            $scope.selectOpenDaySlot = function (slot) {
                viewHandlers.onClick(slot);
            };

            $scope.$on("$destroy", function () {
                viewService.destroy();
                InterviewDataService.reset();
            });
    }]);
